import { List, Record } from "immutable";
import { IRJSFSchema } from ".";

export const fromJSON = (json: Partial<IProductProcessData>): ProductProcessRecords => {
  const record: IProductProcessRecords = { ...(json as any) };

  if (json.errors) {
    record.errors = List(json.errors);
  }

  return new ProductProcessRecords(record);
};

export interface IProductProcessData {
  cached?: boolean;
  errors?: string[];
  list: { [key: string]: IRJSFSchema };
  loading?: boolean;
}

export interface IProductProcessRecords {
  cached: boolean;
  errors: List<string>;
  list: { [key: string]: IRJSFSchema };
  loading: boolean;
}

const defaultProductProcessProps: IProductProcessRecords = {
  cached: false,
  errors: List<string>(),
  list: {},
  loading: false,
};

export class ProductProcessRecords extends Record(defaultProductProcessProps) implements IProductProcessRecords {}
